<template>
  <div class="w-100">
    <!-- Thanh tab nằm trong subheader của từng tab, chung hàng với nút Bộ lọc -->
    <lesson-result-tab
      v-if="tabIndex === 0"
      v-model="tabIndex"
      :shared-filters.sync="sharedFilters"
    />
    <kpi-result-tab
      v-if="tabIndex === 1"
      v-model="tabIndex"
      :shared-filters.sync="sharedFilters"
    />
  </div>
</template>

<script>
export default {
  name: 'LessonResultList',
  components: {
    'lesson-result-tab': () => import('./components/LessonResultTab.vue'),
    'kpi-result-tab': () => import('./components/KpiResultTab.vue'),
  },
  data() {
    return {
      tabIndex: 0,
      // Bộ lọc dùng chung giữa 2 tab: chuyển tab vẫn giữ tên/SĐT, nhóm, khoảng ngày
      sharedFilters: {
        keyword: null,
        onboardGroup: null,
        startDate: null,
        endDate: null,
      },
    };
  },
};
</script>
